import { render, staticRenderFns } from "./DpRegister.vue?vue&type=template&id=9a3b204e&scoped=true&"
import script from "./DpRegister.vue?vue&type=script&lang=js&"
export * from "./DpRegister.vue?vue&type=script&lang=js&"
import style0 from "./DpRegister.vue?vue&type=style&index=0&id=9a3b204e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3b204e",
  null
  
)

export default component.exports